<template>
  <BContainer>
    <BRow>
      <BCol class="content-block text-center pr-5 pl-5">
        <div class="pt-5 pb-5">
          <IconCircleCheckFilled variant="success"/>
        </div>
        <h1 class="title">{{ $t('ticket_changed') }}</h1>
        <p class="subtitle m-5">{{ $t('ticket_changed_text') }}</p>
      </BCol>
    </BRow>
  </BContainer>
</template>

<script>
import {BCol, BContainer, BRow} from "bootstrap-vue-next";
import IconCircleCheckFilled from "../components/icons/IconCircleCheckFilled.vue";

export default {
  components: {BCol, BRow, BContainer, IconCircleCheckFilled},
  created(){
    if(document.body.contains(document.getElementById('company-header'))){
      document.getElementById("company-header").scrollIntoView();
    }
    document.title = this.$t('order_thank_you_title')
  }
}
</script>
<style scoped>
h1.title {
  font-size: 2em;
}

p.subtitle {
  font-size: 1.4em;
}
</style>
